"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SearchInput = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _reactAutosuggest = _interopRequireDefault(require("react-autosuggest"));

var _Button = _interopRequireDefault(require("../Button"));

var _Clear = _interopRequireDefault(require("@material-ui/icons/Clear"));

var _Fade = _interopRequireDefault(require("@material-ui/core/Fade"));

var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));

var _TextInput = _interopRequireDefault(require("../TextInput"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("./styles");

var _lodash = require("lodash");

var _notistack = require("notistack");

var _excluded = ["useHotkey", "className", "style", "onSearch", "onSearchSuggestion", "initialWidth", "maxWidth", "onChange", "suggestions", "maxSuggestions", "renderSuggestion", "mustSelectSuggestion", "onClear", "searchOnChange", "placeholder", "AutosuggestProps", "ref", "variant", "value"],
    _excluded2 = ["ref"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var SearchInput = function SearchInput(props) {
  var useHotkey = props.useHotkey,
      className = props.className,
      style = props.style,
      onSearch = props.onSearch,
      onSearchSuggestion = props.onSearchSuggestion,
      initialWidth = props.initialWidth,
      maxWidth = props.maxWidth,
      _onChange = props.onChange,
      suggestions = props.suggestions,
      maxSuggestions = props.maxSuggestions,
      renderSuggestion = props.renderSuggestion,
      mustSelectSuggestion = props.mustSelectSuggestion,
      onClear = props.onClear,
      searchOnChange = props.searchOnChange,
      placeholder = props.placeholder,
      AutosuggestProps = props.AutosuggestProps,
      ref = props.ref,
      variant = props.variant,
      value = props.value,
      others = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classes = (0, _styles.useStyles)(props);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var inputRef = (0, _react.useRef)();

  var _useState3 = (0, _react.useState)([]),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      renderedSuggestions = _useState4[0],
      setRenderedSuggestions = _useState4[1]; // Only used when not controlled, otherwise use onChange and value


  var _useState5 = (0, _react.useState)(""),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      uncontrolledValue = _useState6[0],
      setUncontrolledValue = _useState6[1]; // useEffect(() => {
  // 	if (others.value !== undefined && value !== others.value) setUncontrolledValue(others.value);
  // }, [others.value, value]);


  var _useSnackbar = (0, _notistack.useSnackbar)(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar;

  var sortSuggestions = function sortSuggestions(a, b) {
    return a.index < b.index ? -1 : a.index > b.index ? 1 : a.value.text < b.value.text ? -1 : a.value.text > b.value.text ? 1 : 0;
  };

  var getSuggestions = (0, _react.useCallback)(function (value) {
    if (typeof onSearchSuggestion === "function") return false;
    var testValue = value.trim().toLowerCase();

    if (testValue.length > 0) {
      var weightedSuggestions = [];
      suggestions === null || suggestions === void 0 ? void 0 : suggestions.forEach(function (suggestion) {
        var index = suggestion.text.toLowerCase().indexOf(testValue);
        if (index !== -1) weightedSuggestions.push({
          value: suggestion,
          index: index
        });
      });
      weightedSuggestions.sort(sortSuggestions);
      setRenderedSuggestions(weightedSuggestions.slice(0, maxSuggestions).map(function (weightedSuggestion) {
        return weightedSuggestion.value;
      }));
    } else {
      setRenderedSuggestions([]);
    }
  }, [maxSuggestions, suggestions, onSearchSuggestion]);

  var handleFocus = function handleFocus() {
    return setFocused(true);
  };

  var handleBlur = function handleBlur() {
    return setFocused(false);
  };

  var handleClear = function handleClear() {
    setUncontrolledValue("");

    if (typeof _onChange === "function") {
      _onChange({
        target: {
          value: ""
        }
      });
    }

    if (typeof onClear === "function") onClear();
  };

  var handleSearch = function handleSearch() {
    if (typeof onSearch === "function") {
      var _inputRef$current;

      (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.blur();
      setTimeout(function () {
        return handleBlur();
      }, 100); // Small delay added to ensure animation fired

      onSearch(value !== undefined ? value : uncontrolledValue);
    }
  };

  (0, _react.useEffect)(function () {
    var listener;

    if (inputRef.current && useHotkey) {
      listener = function listener(event) {
        if ((event.ctrlKey || event.metaKey) && event.key === "k") {
          var _inputRef$current2, _inputRef$current3;

          event.preventDefault();
          (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.focus();
          (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 ? void 0 : _inputRef$current3.select();
        }
      };

      document.addEventListener("keydown", listener);
    }

    return function () {
      if (inputRef && useHotkey) {
        document.removeEventListener("keydown", listener);
      }
    };
  }, [inputRef, useHotkey]);
  (0, _react.useEffect)(function () {
    if (suggestions) {
      getSuggestions(value !== undefined ? value : uncontrolledValue);
    }
  }, [value, suggestions, getSuggestions, uncontrolledValue]);

  var handleKeyDown = function handleKeyDown(event) {
    // Handle enter press on input
    if (event.keyCode === 13) {
      handleSearch();
    } else if (event.key === "Escape") {
      var _inputRef$current4;

      (_inputRef$current4 = inputRef.current) === null || _inputRef$current4 === void 0 ? void 0 : _inputRef$current4.blur();
      handleBlur();
    }
  };

  var renderedTextInputProps = _objectSpread(_objectSpread({}, others), {}, {
    className: (0, _classnames.default)(className, classes.root),
    value: value !== undefined ? value : uncontrolledValue,
    variant: variant,
    onKeyDown: handleKeyDown,
    onFocus: handleFocus,
    onBlur: handleBlur,
    style: {
      width: focused ? "100%" : "".concat(initialWidth, "%")
    },
    placeholder: placeholder,
    inputProps: _objectSpread({
      "aria-label": "label" in others ? undefined : placeholder,
      ref: inputRef
    }, others.inputProps),
    endAdornment: (_onChange || mustSelectSuggestion) && searchOnChange ? value === "" || value === undefined && uncontrolledValue === "" ? /*#__PURE__*/_react.default.createElement(_InputAdornment.default, {
      position: "end"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: "icon",
      size: variant === "compact" ? "small" : undefined,
      "aria-label": "Search",
      disabled: true
    }, /*#__PURE__*/_react.default.createElement(_Search.default, {
      fontSize: "small"
    }))) : /*#__PURE__*/_react.default.createElement(_InputAdornment.default, {
      position: "end"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: "icon",
      size: variant === "compact" ? "small" : undefined,
      title: "Clear search",
      onClick: handleClear
    }, /*#__PURE__*/_react.default.createElement(_Clear.default, {
      fontSize: "small"
    }))) : value === "" || value === undefined && uncontrolledValue === "" ? /*#__PURE__*/_react.default.createElement(_InputAdornment.default, {
      position: "end"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: "icon",
      size: variant === "compact" ? "small" : undefined,
      "aria-label": "Search",
      disabled: true
    }, /*#__PURE__*/_react.default.createElement(_Search.default, {
      fontSize: "small"
    }))) : /*#__PURE__*/_react.default.createElement(_InputAdornment.default, {
      position: "end"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: "icon",
      size: variant === "compact" ? "small" : undefined,
      title: "Search",
      onClick: handleSearch
    }, /*#__PURE__*/_react.default.createElement(_Search.default, {
      fontSize: "small"
    })))
  });

  var renderInputComponent = function renderInputComponent(props) {
    var ref = props.ref,
        others = (0, _objectWithoutProperties2.default)(props, _excluded2);
    if (typeof ref === "function") ref(inputRef);
    return /*#__PURE__*/_react.default.createElement(_TextInput.default, (0, _extends2.default)({}, renderedTextInputProps, others, {
      size: renderedTextInputProps.size
    }));
  };

  var renderSuggestionsContainer = function renderSuggestionsContainer(_ref) {
    var containerProps = _ref.containerProps,
        children = _ref.children;
    return /*#__PURE__*/_react.default.createElement(_Fade.default, {
      in: true
    }, /*#__PURE__*/_react.default.createElement(_Paper.default, containerProps, children));
  };

  renderSuggestionsContainer.propTypes = {
    containerProps: _propTypes.default.object,
    children: _propTypes.default.node
  };

  var onSuggestionsClearRequested = function onSuggestionsClearRequested() {
    setRenderedSuggestions([]);
  };

  var localRenderSuggestion = function localRenderSuggestion(suggestion, otherProps) {
    if (typeof renderSuggestion === "function") {
      return renderSuggestion(suggestion, otherProps);
    } else {
      var _query = otherProps.query;
      var queryIndexStart = suggestion.text.toLowerCase().indexOf(_query.toLowerCase());
      var queryIndexEnd = queryIndexStart + _query.length;
      var before = suggestion.text.slice(0, queryIndexStart);
      var highlighted = suggestion.text.slice(queryIndexStart, queryIndexEnd);
      var after = suggestion.text.slice(queryIndexEnd, suggestion.text.length);
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, before, /*#__PURE__*/_react.default.createElement("strong", null, highlighted), after);
    }
  };

  var getSuggestionValue = function getSuggestionValue(suggestion) {
    return suggestion.text;
  };

  var theme = {
    container: classes.container,
    suggestionsContainer: classes.suggestionsContainer,
    suggestionsList: classes.suggestionsList,
    suggestion: classes.suggestion,
    suggestionHighlighted: classes.suggestionHighlighted
  };

  var handleSearchSuggestionRequest = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref2) {
      var value, items;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              value = _ref2.value;

              if (!(value.length > 0 && onSearchSuggestion)) {
                _context.next = 12;
                break;
              }

              _context.prev = 2;
              _context.next = 5;
              return onSearchSuggestion(value);

            case 5:
              items = _context.sent;
              setRenderedSuggestions(items);
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](2);
              enqueueSnackbar("We couldn't fetch the suggestion list. It may be due to some network instability. Try again later.", {
                variant: "error"
              });

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 9]]);
    }));

    return function handleSearchSuggestionRequest(_x) {
      return _ref3.apply(this, arguments);
    };
  }(); // Use the dependencies from the function inside of debounce
  // eslint-disable-next-line react-hooks/exhaustive-deps


  var debounceSearchSuggestions = (0, _react.useCallback)((0, _lodash.debounce)(handleSearchSuggestionRequest, 300), [onSearchSuggestion, enqueueSnackbar]);

  if (process.env.NODE_ENV === "development") {
    if (typeof onSearchSuggestion === "function" && suggestions) {
      // eslint-disable-next-line no-console
      console.warn("suggestions prop will be ignored and use instead the list coming from onSearchSuggestion prop.");
    }
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.outerWrapper,
    style: _objectSpread({
      maxWidth: maxWidth
    }, style)
  }, suggestions ? /*#__PURE__*/_react.default.createElement(_reactAutosuggest.default, (0, _extends2.default)({
    suggestions: renderedSuggestions,
    onSuggestionsFetchRequested: debounceSearchSuggestions,
    onSuggestionsClearRequested: onSuggestionsClearRequested,
    getSuggestionValue: getSuggestionValue,
    renderSuggestion: localRenderSuggestion,
    inputProps: _objectSpread(_objectSpread({}, renderedTextInputProps), {}, {
      onChange: function onChange(e, suggestStuff) {
        var newValue = suggestStuff.newValue,
            method = suggestStuff.method;
        setUncontrolledValue(newValue);

        if (method === "type") {
          getSuggestions(newValue);
          if (typeof _onChange === "function") _onChange({
            target: {
              value: newValue
            }
          });
        } else if (typeof onSearch === "function") {
          if (method === "click") {
            onSearch(newValue);
          } else if (method === "enter") {
            onSearch(newValue);
          }
        }
      },
      size: undefined
    }),
    renderInputComponent: renderInputComponent,
    theme: theme,
    renderSuggestionsContainer: renderSuggestionsContainer,
    focusInputOnSuggestionClick: false,
    highlightFirstSuggestion: mustSelectSuggestion,
    "aria-label": placeholder
  }, AutosuggestProps)) : /*#__PURE__*/_react.default.createElement(_TextInput.default, (0, _extends2.default)({}, renderedTextInputProps, {
    onChange: function onChange(e) {
      setUncontrolledValue(e.target.value);
      if (typeof _onChange === "function") _onChange(e);
    }
  })));
};

exports.SearchInput = SearchInput;
SearchInput.defaultProps = {
  placeholder: "Search...",
  initialWidth: 100,
  maxWidth: "100%",
  maxSuggestions: 6
};
var _default = SearchInput;
exports.default = _default;